import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CatalogsService } from '@fb-tool-front/core/services/catalogs.service';
import { ProductCatalog } from '../interfaces/catalogs.type';
import { ErrorService } from '@fb-tool-front/core/services/error.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogsResolver implements Resolve<Observable<ProductCatalog[] | never>> {
  constructor(private catalogsService: CatalogsService, private errorService: ErrorService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.catalogsService.getCatalogs(route?.data?.withoutCache).pipe(
      catchError(err => {
        this.errorService.captureError(err);

        return of([]);
      })
    );
  }
}
